// Import and register all your controllers
import { application } from "./application.js"

// Register controllers manually
import HelloController from "./hello_controller.js"
import SortableController from "./sortable_controller.js"
import TiptapController from "./tiptap_controller.js"
import TagsController from "./tags_controller.js"
import PhotoswipeController from "./photoswipe_controller.js"
import AosController from "./aos_controller.js"
import NestedFormController from "./nested_form_controller.js"

application.register("hello", HelloController)
application.register("sortable", SortableController)
application.register("tiptap", TiptapController)
application.register("tags", TagsController)
application.register("photoswipe", PhotoswipeController)
application.register("aos", AosController)
application.register("nested-form", NestedFormController)
